/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AnswerOption } from './AnswerOption';
import { AnswerOptionFromJSON, AnswerOptionFromJSONTyped, AnswerOptionToJSON } from './AnswerOption';

/**
 *
 * @export
 * @interface PaginatedAnswerOptionList
 */
export interface PaginatedAnswerOptionList {
  /**
   *
   * @type {number}
   * @memberof PaginatedAnswerOptionList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedAnswerOptionList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedAnswerOptionList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<AnswerOption>}
   * @memberof PaginatedAnswerOptionList
   */
  results: Array<AnswerOption>;
}

/**
 * Check if a given object implements the PaginatedAnswerOptionList interface.
 */
export function instanceOfPaginatedAnswerOptionList(value: object): value is PaginatedAnswerOptionList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedAnswerOptionListFromJSON(json: any): PaginatedAnswerOptionList {
  return PaginatedAnswerOptionListFromJSONTyped(json, false);
}

export function PaginatedAnswerOptionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedAnswerOptionList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(AnswerOptionFromJSON),
  };
}

export function PaginatedAnswerOptionListToJSON(value?: PaginatedAnswerOptionList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(AnswerOptionToJSON),
  };
}
